import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';

type UseWebsiteV2FeatureReturnType = Readonly<{
  value: boolean;
  isLoading: boolean;
}>;

/**
 * Per-event `useWebsiteV2` flag: the carbon website editor fully replaces the admin website
 * experience (editor route, absorbed page-editor routes, nav/dashboard website surface) for the
 * event. Super-admin toggled in the Event Service Center; no remote-flag component on purpose —
 * rollout is entirely per-event. See doc/website-v2/PLAN.md.
 *
 * `isLoading` is true until the flag source resolves — callers must wait before acting on
 * `value`, otherwise routing decisions can fire against the loading-default `false`.
 */
export const useWebsiteV2Feature = (): UseWebsiteV2FeatureReturnType => {
  const [isEnabled, isFlagLoading] = useIsFeatureEnabled({ eventFeatureFlagKey: 'useWebsiteV2' });

  return useMemo(
    () => ({
      value: isEnabled,
      isLoading: isFlagLoading,
    }),
    [isEnabled, isFlagLoading],
  );
};
